import { Component, computed, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';
import { CategoriesStore } from './categories.store';

@Component({
  selector: 'app-category-nav',
  imports: [RouterModule],
  templateUrl: './category-nav.component.html',
  styleUrl: './category-nav.component.scss',
})
export class CategoryNavComponent {
  /** Bound on catalog pages so the active category is highlighted. */
  readonly selectedSlug = input<string | null | undefined>();

  readonly store = inject(CategoriesStore);
  readonly open = signal(false);

  readonly onCatalog = computed(() => this.selectedSlug() !== undefined);
  readonly selectedName = computed(() => {
    const slug = this.selectedSlug();
    if (!this.onCatalog()) return 'Каталог';
    return this.store.bySlug(slug ?? null)?.name ?? 'Всі товари';
  });

  constructor(router: Router) {
    router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => this.open.set(false));
  }

  toggle(): void {
    this.open.update((open) => !open);
  }
}
